/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScanStatus = {
    _11184809: '11184809',
    WINNER: 'WINNER',
    NOT_A_WINNER: 'NOT_A_WINNER',
    NO_DRAWS: 'NO_DRAWS',
    CANCELLED: 'CANCELLED',
    ALREADY_CLAIMED: 'ALREADY_CLAIMED',
    NOT_ACTIVATED: 'NOT_ACTIVATED',
    ON_HOLD: 'ON_HOLD',
    EXPIRED: 'EXPIRED',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
    INELIGIBLE: 'INELIGIBLE',
    INVALID_BARCODE: 'INVALID_BARCODE',
    ERROR: 'ERROR',
    PENDING: 'PENDING',
    unknown_default_open_api: '11184809'
} as const;
export type ScanStatus = typeof ScanStatus[keyof typeof ScanStatus];


export function instanceOfScanStatus(value: any): boolean {
    for (const key in ScanStatus) {
        if (Object.prototype.hasOwnProperty.call(ScanStatus, key)) {
            if (ScanStatus[key as keyof typeof ScanStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ScanStatusFromJSON(json: any): ScanStatus {
    return ScanStatusFromJSONTyped(json, false);
}

export function ScanStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScanStatus {
    return json as ScanStatus;
}

export function ScanStatusToJSON(value?: ScanStatus | null): any {
    return value as any;
}

